import Grid from '@material-ui/core/Grid';
import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { hideBuyPermitsExitOrderModal, resetBuyPermitSelectedPermit } from '../../../store/buyPermits/action';
import { useDispatch } from 'react-redux';



const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },
  vin: {
    textAlign: 'left',
    marginTop: 15,
  },
  additionalDetails: {
    textAlign: 'left',
    fontSize: '20px',
    fontWeight: 'bold'
  },
  txtLeft: {
    textAlign: 'left',
    width: '100%',
  },
  textInput: {
    width: '100%',
    BorderBottom: '1px solid gray'
  },
  selectBox: {
    width: '100%',
    height: 50,
  },
  btnConfirm: {
    paddingLeft: 8,
    paddingRight: 8,
    borderRadius:10,
    height:23,
  },
  btnRow: {
    textAlign: 'right',
    marginTop: 20,
  },
  txt:{
    fontSize:12,
  }

}));

const BuyPermitsExitOrderModalForm = (props) => {
 const { CancelBuyPermitsExitOrderModal,ConfirmBuyPermitsExitOrderModal } = props;
  const classes = useStyles();
  const dispatch = useDispatch();



  return (
    <>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <div className={classes.txt}>Order will not be saved if you leave this page.</div>
            <div className={classes.txt}>Do you wish to continue?</div>
          </Grid> 
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.btnRow} >
            <Button onClick={CancelBuyPermitsExitOrderModal}>Cancel</Button>
            <Button onClick={ConfirmBuyPermitsExitOrderModal} variant="contained" type={'submit'} color="primary" className={classes.btnConfirm}>
              Confirm
            </Button>
          </Grid>
        </Grid>
    </>
  )
}

export default BuyPermitsExitOrderModalForm;
